<template>
<drawer :opened.sync="opened" style="width:1200px;" @close="onCloseBtnClick">
  <template #header>批量人工审核</template>

  <template slot="toolbar">
    <section style="float:left;">
      <el-button
        type="warning"
        size="mini"
        icon="el-icon-check"
        style="margin-left:0"
        @click="onSelectAllExceptionBtnClick"
      >全选未审核异常</el-button>

      <el-button
        type="success"
        size="mini"
        icon="el-icon-check"
        style="margin-left:0"
        @click="onSelectAllReserveBtnClick"
      >全选保留</el-button>

      <el-button
        type="danger"
        size="mini"
        icon="el-icon-check"
        style="margin-left:0"
        @click="onSelectAllDeleteBtnClick"
      >全选剔除</el-button>
    </section>

    <audit-operator-btn-group
      ref="auditOperator"
      :model="model"
      :disabled="selectedDataIds.length === 0"
      style="float:left;margin-left:1em;"
      @change="onAuditChanged"
    />
  </template>

  <template #body>
    <section class="data-list" :style="{
      '--batch-data-list-grid-columns': relatedChartDataList.length > 0 ? 'auto 420px' : 'auto'
    }">
      <section class="batch-process-table">
        <el-table
          ref="table"
          :key="tableKey"
          row-key="id"
          :data="auditDataList"
          height="100%"
          border
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
          style="width: 100%"
          @select="onDataSelect"
          @select-all="onAllDataSelect"
        >
          <el-table-column type="selection" width="38" fixed />
          <el-table-column label="时间" prop="dataTime" fixed width="125" />

          <el-table-column
            v-for="column in filterDataList"
            :key="column.id"
            min-width="150"
          >
            <template slot="header" slot-scope="scope">
              <el-checkbox v-model="selectedColumn" :label="column" @change="selectedColumnChange">{{column.name}}</el-checkbox>
            </template>

            <template slot-scope="{row}">
              <span v-if="row.data[column.id].id" style="display:flex">
                <el-checkbox v-model="selectedDataIds" :label="row.data[column.id].id" @change="checked => onSelectedDataIdsChanged(checked, row)"><span></span></el-checkbox>
                <span
                    :has-exception-flag="row.data[column.id].autoFlag !== 'N'"
                    :audit-flag="row.data[column.id].auditFlag"
                    :is-regen="Number.isFinite(row.data[column.id].originalValue)"
                    class="flag-value"
                    style="display:inline-block;margin-left:-5px;"
                    @click="onValueClick(row, column.id)"
                  >{{row.data[column.id].value}}{{column[currentUnitKey]}}</span>
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </section>

      <section class="related-chart-group-wrapper">
        <section
          v-for="(relatedChart, index) in relatedChartDataList"
          :key="index"
          class="related-chart">
          <related-chart
            :base-data="relatedChart.x"
            :related-data="relatedChart.y"
          />
        </section>
      </section>

      <div v-if="isShowMinuteData" class="minute-data-wrapper"></div>
    </section>
  </template>

  <template #footer>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import AuditOperatorBtnGroup from './AuditOperatorBtnGroup'

import {PROCESS_PANEL_SAVE, SHOW_BATCH_PROCESS_PANEL} from './EventKeys'
import RelatedChart from '../../../components/Data/RelatedChart'
import unitConverter from '@/utils/unitConverter'

export default {
  name: 'BatchProcessPanel',
  components: {RelatedChart, AuditOperatorBtnGroup},
  extends: BaseStore,
  props: {
    stage: {
      required: true,
      type: Number
    },
    siteDevice: {
      required: true
    },
    auditRuleCategories: {
      required: true,
      type: Array
    },
    dataTimes: {
      required: true,
      type: Array
    },
    dataList: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      opened: false,
      selectedFactorIds: [],
      selectedColumn: [],
      selectedDataIds: [],
      selects: [],
      model: {
        operatorType: 0,
        comment: ''
      },
      tableKey: new Date().getTime(),
      relatedChartDataList: [],
      flag: true,
      currentUnitKey: 'displayUnit'
    }
  },
  computed: {
    auditFactorIdMap () {
      return this.selectedFactorIds.reduce((map, factorId) => {
        map[factorId] = true
        return map
      }, {})
    },
    filterDataList () {
      let {auditFactorIdMap} = this
      return this.dataList.filter(data => auditFactorIdMap[data.id])
    },
    auditDataList () {
      let {filterDataList, dataTimes} = this

      return dataTimes.map((dataTime, index) => ({
        dataTime: dataTime.format('YYYY-MM-DD HH'),
        data: filterDataList.reduce((map, data) => {
          let value = data.data[index]
          map[data.id] = {
            id: value.id,
            dasValue: value.dasValue,
            dasFlag: value.dasFlag,
            value: Number(unitConverter(value.value, data.stdUnit, data[this.currentUnitKey], data.molecular).toFixed(data.decimalNum)),
            autoFlag: value.autoFlag,
            auditFlag: value.auditFlag,
            auditComment: value.auditComment,
            originalFlag: value.originalFlag,
            originalValue: value.originalValue
          }
          return map
        }, {})
      }))
    },
    isShowMinuteData () {
      return this.siteDevice.deviceCategoryId & (
        process.env.METEOROLOGICAL_DEVICE_CATEGORY |
        process.env.SO2_DEVICE_CATEGORY |
        process.env.NO_DEVICE_CATEGORY |
        process.env.CO_DEVICE_CATEGORY |
        process.env.O3_DEVICE_CATEGORY |
        process.env.PM_DEVICE_CATEGORY |
        process.env.NMHC_DEVICE_CATEGORY
      )
    }
  },
  methods: {
    // 取出两个数组的不同元素
    getArrDifference (arr1, arr2) {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    selectedColumnChange (item) {
      let {selectedColumn, selects} = this
      let data = JSON.parse(JSON.stringify(selectedColumn)).map(el => el.data)
      // 通过列选择的所有ids
      let columnDataIds = data.flat().map(el => el.id)

      if (item) {
        // 通过列全选表格所有表格ids
        if (selectedColumn.length === this.filterDataList.length) {
          this.selects = columnDataIds
          this.getRefTable().clearSelection()
          this.getRefTable().toggleAllSelection(true)
          return
        }
        // 保留通过列选择的Ids
        this.selects = columnDataIds
        // 设置选中ids
        this.selectedDataIds = Array.from(new Set(this.selectedDataIds.concat(columnDataIds))).filter(el => el)
      } else {
        this.getRefTable().clearSelection()
        // 当前列选中大于0
        if (selectedColumn.length > 0) {
          // 保留当前通过列选中的ids
          this.selects = columnDataIds
          // 取出多余ids
          let ids = this.getArrDifference(selects, columnDataIds)
          // 设置选中的checkbox
          this.selectedDataIds = this.getArrDifference(ids, this.selectedDataIds)
        } else {
          // 设置选中的checkbox 删掉所有通过列选择的ids保留通过行选择的ids和手选ids
          this.selectedDataIds = this.getArrDifference(selects, this.selectedDataIds)
        }
      }
    },
    open () {
      let refAuditOperator = this.$refs.auditOperator
      refAuditOperator && refAuditOperator.clear()
      this.selectedDataIds = []
      this.selectedColumn = []
      this.opened = true
    },
    close () {
      this.opened = false
    },
    onCloseBtnClick () {
      this.close()
    },
    onShowBathProcessPanel (selectedFactorIds) {
      this.selectedFactorIds = selectedFactorIds
      this.tableKey = new Date().getTime()
      this.open()
    },
    setRelatedCharts () {
      let {filterDataList, relatedFactorMap} = this
      let dataMap = this.dataList.reduce((map, data) => {
        map[data.id] = data
        return map
      }, {})

      this.relatedChartDataList = Object.freeze(Object.values(filterDataList.reduce((map, auditData) => {
        let xFactorId = auditData.id
        let tmpMap = relatedFactorMap[xFactorId]

        if (tmpMap) {
          for (let yFactorId in tmpMap) {
            if (map.hasOwnProperty(`${yFactorId}-${xFactorId}`)) {
              continue
            }

            let relatedData = dataMap[yFactorId]

            if (relatedData) {
              map[`${xFactorId}-${yFactorId}`] = {
                x: {
                  ...auditData,
                  data: auditData.data.map(data => ({
                    ...data,
                    value: data.auditFlag === 'DELETE' ? null : data.value
                  }))
                },
                y: {
                  ...relatedData,
                  data: relatedData.data.map(data => ({
                    ...data,
                    value: data.auditFlag === 'DELETE' ? null : data.value
                  }))
                }
              }
            }
          }
        }

        return map
      }, {})))
    },
    onAuditChanged () {
      let {model} = this
      this.changeLoadStatus(true)

      this.$api.Audit.updateAuditFlag({
        siteDeviceId: this.siteDevice.id,
        auditFlag: model.operatorType,
        auditComment: model.comment,
        ids: this.selectedDataIds
      }).then(data => {
        if (data) {
          this.$eventBus.emit(PROCESS_PANEL_SAVE)
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDataSelect (selection, row) {
      if (selection.length === 24) {
        this.selectedColumn = this.filterDataList
      }
      let {data} = row
      let {selectedDataIds} = this
      let selectedDataIdMap = this.getSelectedDataMap()
      let dataList = Object.values(data)

      if (selection.indexOf(row) > -1) {
        let temp = []
        dataList.forEach(data => {
          let dataId = data.id

          if (!selectedDataIdMap[dataId]) {
            selectedDataIds.push(dataId)
            temp.push(dataId)
          }
        })
        this.selects = Array.from(new Set(this.selects.concat(temp))).filter(el => el)
      } else {
        dataList.forEach(data => {
          let dataId = data.id

          if (selectedDataIdMap.hasOwnProperty(dataId)) {
            delete selectedDataIdMap[dataId]
          }
        })

        this.selectedColumn = []
        this.selectedDataIds = Object.keys(selectedDataIdMap)
        this.selects = Object.keys(selectedDataIdMap)
      }
    },
    onAllDataSelect (selection) {
      if (selection.length > 0) {
        this.selectedColumn = this.filterDataList
        let data = JSON.parse(JSON.stringify(this.filterDataList)).map(el => el.data)
        // 通过列选择的所有ids
        let columnDataIds = data.flat().map(el => el.id)
        this.selects = columnDataIds
      } else {
        this.selectedColumn = []
      }
      let data = selection.reduce((list, {data}) => {
        return Object.values(data).reduce((list, data) => {
          let dataId = data.id

          if (dataId) {
            list.push(dataId)
          }

          return list
        }, list)
      }, [])

      this.selectedDataIds = data
    },
    onSelectedDataIdsChanged (flag, row) {
      if (!flag) {
        let selectedDataIdMap = this.getSelectedDataMap()
        this.selects = Object.keys(selectedDataIdMap)
      }
      this.setTableSelection(row)
    },
    onSelectAllExceptionBtnClick () {
      this.setSelectedDataIdList(data => data.autoFlag === 'N' || data.auditFlag)
    },
    onSelectAllReserveBtnClick () {
      this.setSelectedDataIdList(data => data.auditFlag !== 'RESERVE')
    },
    onSelectAllDeleteBtnClick () {
      this.setSelectedDataIdList(data => data.auditFlag !== 'DELETE')
    },
    setSelectedDataIdList (callback) {
      let selectedDataIdMap = this.getSelectedDataMap()
      let {selectedDataIds} = this
      let rows = []

      this.auditDataList.forEach(row => {
        let {data} = row
        let flag = false

        Object.values(data).forEach(data => {
          let dataId = data.id

          if (dataId === null || selectedDataIdMap[dataId] || callback(data)) {
            return
          }

          selectedDataIds.push(dataId)
          flag = true
        })

        if (flag) {
          rows.push(row)
        }
      })

      rows.forEach(this.setTableSelection)
    },
    getSelectedDataMap () {
      return this.selectedDataIds.reduce((map, dataId) => {
        map[dataId] = true
        return map
      }, {})
    },
    setTableSelection (row) {
      let {data} = row
      let selectedDataIdMap = this.getSelectedDataMap()
      let colTemp = {}
      let rowTemp = {}
      // Object.keys(data).forEach(el => {
      //   colTemp[el] = []
      //   Object.keys(selectedDataIdMap).forEach(item => {
      //     if (item.indexOf(el) !== -1) {
      //       colTemp[el].push(1)
      //     }
      //   })
      // })
      console.time('1111')
      for (let key in data) {
        colTemp[key] = []
        let k = data[key].id.slice(0, 10)
        rowTemp[k] = []
        Object.keys(selectedDataIdMap).forEach(item => {
          if (item.indexOf(key) !== -1) {
            colTemp[key].push(1)
          }
          if (item.slice(0, 10) === k) {
            rowTemp[k].push(1)
          }
        })
      }
      console.timeEnd('1111')

      // Object.values(data).forEach(el => {
      //   let k = el.id.slice(0, 10)
      //   rowTemp[k] = []
      //   Object.keys(selectedDataIdMap).forEach(item => {
      //     if (item.slice(0, 10) === k) {
      //       rowTemp[k].push(1)
      //     }
      //   })
      // })

      console.time('2222')
      for (let key in colTemp) {
        if (colTemp[key].length !== 24) {
          this.selectedColumn = this.selectedColumn.filter(el => el.id !== key)
        } else {
          this.selectedColumn = this.selectedColumn.concat([this.filterDataList.find(el => el.id === key)])
        }
      }
      console.timeEnd('2222')

      console.time('3333')
      for (let key in rowTemp) {
        if (rowTemp[key].length === this.filterDataList.length) {
          this.getRefTable().toggleRowSelection(row, true)
        } else {
          this.getRefTable().toggleRowSelection(row, false)
        }
      }
      console.timeEnd('3333')
      // this.getRefTable().toggleRowSelection(row, Object.values(data).some(data => selectedDataIdMap[data.id]))
    },
    getRefTable () {
      return this.$refs.table
    },
    onSetCurrentUnitKey (unit) {
      this.currentUnitKey = unit
    },
    onValueClick (data, factorId) {
      if (!this.isShowMinuteData) {
        return
      }

      const {dataTime} = data
      this.$eventBus.emit('onValueClick', dataTime, factorId)
    }
  },
  watch: {
    filterDataList (filterDataList) {
      if (this.opened) {
        this.setRelatedCharts()
      }
    }
  },
  created () {
    this.$eventBus.on(SHOW_BATCH_PROCESS_PANEL, this.onShowBathProcessPanel)
    this.$eventBus.on('setCurrentUnitKey', this.onSetCurrentUnitKey)
  },
  beforeDestroy () {
    this.$eventBus.off(SHOW_BATCH_PROCESS_PANEL, this.onShowBathProcessPanel)
    this.$eventBus.on('setCurrentUnitKey', this.onSetCurrentUnitKey)
  }
}
</script>

<style lang="scss" scoped>
.data-list {
  display: grid;
  grid-template-columns: var(--batch-data-list-grid-columns);
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    };
    height: 100%;
  }

  > .related-chart-group-wrapper {
    padding-left: 20px;
    overflow: auto;

    > .related-chart {
      width: 100%;
      height: 400px;
    }
  }
}

.flag-value {
  padding: 2px 3px;
  color: #606266;
  cursor: pointer;

  &[has-exception-flag="true"] {
    color: #E6A23C;
  }

  &[audit-flag="RESERVE"] {
    /*border: 1px solid #e1f3d8 {*/
    /*  radius: 4px;*/
    /*};*/
    /*background-color: #f0f9eb;*/
    border: 1px solid #67C23A {
      radius: 4px;
    };
  }

  &[audit-flag="DELETE"] {
    text-decoration: line-through;
  }

  &[is-regen] {
    color: #67C23A;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/BatchProcessPanel.vue